import * as React from "react"
import { cn } from "../../lib/utils"

const Alert = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
  const variants = {
    default: "bg-surface-2 border-white/10 text-ink",
    error: "bg-red-500/10 border-red-500/30 text-red-400 [&>svg]:text-red-400",
    warning: "bg-yellow-500/10 border-yellow-500/30 text-yellow-400 [&>svg]:text-yellow-400",
    success: "bg-brand-green/10 border-brand-green/30 text-brand-green [&>svg]:text-brand-green",
    info: "bg-blue-500/10 border-blue-500/30 text-blue-400 [&>svg]:text-blue-400",
  }

  return (
    <div
      ref={ref}
      role="alert"
      className={cn(
        "relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-ink-dim [&>svg~*]:pl-7",
        variants[variant],
        className
      )}
      {...props}
    />
  )
})
Alert.displayName = "Alert"

const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/heading-has-content
  <h5 ref={ref} className={cn("mb-1 font-medium leading-none tracking-tight", className)} {...props} />
))
AlertTitle.displayName = "AlertTitle"

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("text-sm [&_p]:leading-relaxed", className)} {...props} />
))
AlertDescription.displayName = "AlertDescription"

export { Alert, AlertTitle, AlertDescription }
